import {
  ICatalogsResponse,
  ICurrencyEntry,
  IEquipmentSlot,
  IRarity,
  ISkillEntry,
  IStatEntry,
  useGetCatalogsQuery
} from "@/store/apis/catalogsAPI"

// Module-level so selectFromResult hands back stable references. A fresh []
// per render would change identity every render and defeat the rarityRank memo
// in useInventorySortSearch.
const EMPTY_SLOT_LAYOUT: IEquipmentSlot[] = []
const EMPTY_RARITIES: IRarity[] = []
const EMPTY_STATS: IStatEntry[] = []
const EMPTY_SKILLS: ISkillEntry[] = []
const EMPTY_CURRENCIES: ICurrencyEntry[] = []

// The single read seam for reference data, and the only place the soft-fallback
// policy lives: a missing catalog degrades to empty arrays rather than throwing.
export const useCatalogs = (): ICatalogsResponse =>
  useGetCatalogsQuery(undefined, {
    selectFromResult: ({ data }) => ({
      slotLayout: data?.slotLayout ?? EMPTY_SLOT_LAYOUT,
      rarities: data?.rarities ?? EMPTY_RARITIES,
      stats: data?.stats ?? EMPTY_STATS,
      skills: data?.skills ?? EMPTY_SKILLS,
      currencies: data?.currencies ?? EMPTY_CURRENCIES
    })
  })
